import React, { useState } from 'react';
import { useGetOrganizationQuery, useUploadPhysicianPhoneNumberFileMutation } from '../../../../api/organizationSlice';
import { Stack, Typography, Button, IconButton } from '@mui/material';
import { useParams } from 'react-router';
import { Upload, Delete } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';


function PhoneNumberUpload() {
    const { organizationId } = useParams();
    const { data: organization } = useGetOrganizationQuery(organizationId);
    const [uploadFile, { isLoading }] = useUploadPhysicianPhoneNumberFileMutation();
    const [files, setFiles] = useState([]);
    const [numberValidationResults, setNumberValidationResults] = useState(null);

    async function handleFileSubmit() {
        if (files.length === 0) {
            return;
        }
        const formData = new FormData();
        formData.append('data', files[0]);
        
        try {
            await uploadFile({ data: formData, organizationId: organizationId }).unwrap().then((response) => {
                setNumberValidationResults(response.number_validity);
            });
            setFiles([]); // Clear files after successful upload
        } catch (error) {
            console.error('File upload failed:', error);
        }
    } 

    return (
        <Stack pl={4} spacing={3}>
            <Stack spacing={1}>
                <Typography variant='heavy' sx={{ fontSize: '24px', marginTop: '20px' }}>
                    <strong>Physician Contacts Management</strong> 
                </Typography>
                <Typography>
                    Organization: <strong>{organization?.name}</strong>
                </Typography>
            </Stack>
            <Stack spacing={1}>
                { files.length > 0 ? 
                    <Stack direction='row' spacing={1} alignItems='center'>
                        <Typography variant='normal' sx={{ fontSize: '16px' }}>{files[0].name}</Typography>
                        <IconButton onClick={() => setFiles([])}>
                            <Delete />
                        </IconButton>
                    </Stack> :
                    <Typography variant='normal' sx={{ fontSize: '16px', color: '#888' }}>
                        No file selected
                    </Typography>
                }
                <Button variant='outlined' disabled={files.length > 0} component='label' startIcon={<Upload />} color='primary' style={{ alignSelf: 'start' }}>
                    Upload Phone Number File
                    <input hidden accept='text/csv' type='file' onChange={(e) => setFiles(e.target.files)} />
                </Button>
                <LoadingButton
                    loading={isLoading}
                    variant='contained'
                    color='primary'
                    style={{ alignSelf: 'start' }}
                    disabled={files.length === 0}
                    onClick={handleFileSubmit}
                >
                    Submit Phone Numbers
                </LoadingButton>
            </Stack>
            { numberValidationResults &&
                <Stack spacing={1}>
                    <Typography variant='heavy' sx={{ fontSize: '20px', marginTop: '20px' }}>
                        Phone Number Validation Results
                    </Typography>
                    { Object.entries(numberValidationResults).map(([key, value]) => (
                        <Typography key={key} variant='normal' sx={{ fontSize: '16px' }}>
                            {key}: {value === true ? 'Valid' : 'Invalid'}
                        </Typography>
                    )) }
                </Stack>
            }
        </Stack>
    );
}

export default PhoneNumberUpload;
